import { Box, Flex } from 'styled-system/jsx';
import AmountDamageImage from '@/modules/adjusterReportModules/IncidentParticipants/assets/images/amount-damage.svg?react';
import Typography from '@/common/components/base/typography/Typography';
import { useQuery } from '@tanstack/react-query';
import { getVehicleDamageAmountQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getVehicleDamageAmount/getVehicleDamageAmountQueryOptions';
import { useParams } from 'react-router-dom';
export const AmountDamageCard = () => {
  const { id, damagedId } = useParams();
  const { data } = useQuery(
    getVehicleDamageAmountQueryOptions({
      id: +id!,
      damaged_id: +damagedId!,
      source: 'pwa',
    }),
  );

  return (
    <Flex
      backgroundColor="white"
      borderRadius="8px"
      shadow="cardShadow"
      justifyContent="center"
      alignItems="center"
      p={19}
    >
      <Flex flex={1}>{<AmountDamageImage />}</Flex>
      <Flex
        flex={2}
        flexDirection="column"
        gap={8}
        justifyContent="center"
        alignItems="center"
      >
        <Typography textStyle="b1">مجموع مبلغ خسارت </Typography>
        <>
          {data ? (
            <Box bg="green-4" px={18} py={4} borderRadius={16}>
              <Typography textStyle="b2" color="green-1">
                {`${data?.toLocaleString('fa')} ریال`}
              </Typography>
            </Box>
          ) : (
            <Box bg="orange-3" px={18} py={4} borderRadius={16}>
              <Typography textStyle="b2" color="orange">
                برآورد نشده است
              </Typography>
            </Box>
          )}
        </>
      </Flex>
    </Flex>
  );
};
export default AmountDamageCard;
